
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { LedgerPostModel } from 'models/generated/Entities.Accounting.LedgerPost';
import { LedgerHeaderModel } from 'models/generated/Entities.Accounting.LedgerHeader';


const _accounting_LedgerPostControllerHelper = new Map<string, Object>();
_accounting_LedgerPostControllerHelper.set('SearchLedgerPosts', LedgerPostModel);
_accounting_LedgerPostControllerHelper.set('GetLedgerHeadersByPostedDocumentNumbers', LedgerHeaderModel);
_accounting_LedgerPostControllerHelper.set('GetLedgerPostsByProductPlanIds', LedgerPostModel);


export const accounting_LedgerPostControllerHelper = _accounting_LedgerPostControllerHelper;

